import { isValidPhoneNumber } from 'react-phone-number-input';

//  DEBUG SWITCH: Set to true to see detailed validation failures in console
const DEBUG_MODE = true;

const logRefusal = (step, checks) => {
    if (DEBUG_MODE) {
        const failed = Object.keys(checks).filter(key => !checks[key]);
        if (failed.length > 0) {
            console.warn(`[Validator] Step ${step} failed checks:`, failed);
            console.table(checks);
        }
    }
};

export const OnboardingValidator = {
  // Step 0: Welcome (Always valid)
  0: () => true,

  // Step 1: Basics
  1: (data) => {
    const checks = {
        hasBirthday: !!data.birthday,
        birthplaceLength: data.birthplace?.trim().length > 2,
        minHeight: data.height > 40,
        minWeight: data.weight > 2,
        hasOccupation: data.occupation?.trim() !== "",
        hasBloodType: data.blood_type !== null && data.blood_type !== "",
        hasMaritalStatus: data.marital_status !== null && data.marital_status !== ""
    };
    const isValid = Object.values(checks).every(Boolean);
    if (!isValid) logRefusal(1, checks);
    return isValid;
  },

  // Step 2: Contact
  2: (data) => {
    const addr = data.current_address;
    const checks = {
        addressFields: addr?.street?.trim() !== "" && addr?.number?.trim() !== "" && addr?.zip_code?.trim() !== "",
        addressState: addr?.state !== "" && addr?.state !== 0 && addr?.state !== null,
        personalPhone: data.phone_numbers.length > 0 && data.phone_numbers.every(p => p && isValidPhoneNumber(p)),
        emergencyContact: data.emergency_contacts.length > 0 && data.emergency_contacts.every(c => 
            c.name?.trim().length > 1 && 
            c.phone && 
            isValidPhoneNumber(c.phone) && 
            c.relationship !== null && 
            c.relationship !== undefined &&
            c.relationship !== ""
        )
    };
    const isValid = Object.values(checks).every(Boolean);
    if (!isValid) logRefusal(2, checks);
    return isValid;
  },

  // Step 3: Substance Use
  3: (data) => {
    const details = data.substances?.substances_detail || [];
    if (details.length === 0) return true;

    const currentYear = new Date().getFullYear();
    const checks = {
        allDetailsFilled: details.every(item => 
            item.substance !== "" && 
            item.behavior_type !== "" && 
            item.year_start?.toString().length === 4 &&
            parseInt(item.year_start, 10) <= currentYear
        )
    };
    const isValid = Object.values(checks).every(Boolean);
    if (!isValid) logRefusal(3, checks);
    return isValid;
  },

  // Step 4: General Health
  4: (data) => {
    const isSexuallyActive = data.sexual_health?.status === true;

    const checks = {
        // Fitness checks
        fitnessLevel: Boolean(data.fitness?.level),
        fitnessFreq: Boolean(data.fitness?.frequency_per_week),
        
        // Diet checks
        mealsValid: Number(data.diet?.meals_per_day) > 0,
        waterValid: Boolean(data.diet?.water_liters),
        junkFoodValid: Boolean(data.diet?.frequency_junk_food),
        dietTypeValid: Boolean(data.diet?.diet_type), // Checks if enum value selected (e.g., NONE or specific diet)
        
        // Sexual health check: If active, partners range and protection method are required
        sexualHealthValid: !isSexuallyActive || (
            isSexuallyActive && 
            Boolean(data.sexual_health?.protection) && 
            Boolean(data.sexual_health?.partners_range)
        )
    };

    const isValid = Object.values(checks).every(Boolean);
    if (!isValid) logRefusal(4, checks);
    return isValid;
  }
};